import { getCurrentMerchantID } from '../features/data'
import { getCurrentMerchantCountryCode } from '../utils/cookiesUtils'
import { useIdentityPermissions } from './useIdentityPermissions'
import {
	getAllowedMerchantCountries,
	getCreateMerchantCountries,
	getPermissionOperation,
	getViewInvoiceRequestCountries,
	hasTargetPermission,
	merchantPermissionMatches,
} from './permissionsV2'

export const usePermissions = () => {
	const { permissions, loading, error } = useIdentityPermissions()
	const permissionsV2 = permissions
	const allowedMerchantCountries = getAllowedMerchantCountries(permissionsV2)
	const createMerchantCountries = getCreateMerchantCountries(permissionsV2)
	const canCreateMerchant = createMerchantCountries.length > 0
	const { currentMerchantID } = getCurrentMerchantID()
	const currentMerchantCountryCode = getCurrentMerchantCountryCode()

	const ownsPermission = permissionName =>
		permissions.some(permission =>
			merchantPermissionMatches({
				permission,
				operation: permissionName,
				currentMerchantID,
				currentMerchantCountryCode,
			}),
		)

	const canSignContract = ownsPermission('sign-contracts')
	const canControlFeatures = ownsPermission('control-features')
	const canManageMarketCompetitors = ownsPermission('manage-market-competitors')
	const canManageAdmins = ownsPermission('manage-account-admins')
	const canManageUsers = ownsPermission('manage-account-users')

	const canSearchMerchantsByPid =
		getAllowedMerchantCountries(
			permissions.filter(permission => getPermissionOperation(permission) === 'control-features'),
		).length > 0

	const canSearchMerchants = allowedMerchantCountries.length > 0

	const canManageCollections = hasTargetPermission({ permissions, operation: 'manage-collections', target: 'market:*' })

	const canManageSuperdeals = ownsPermission('manage-superdeals')

	const canViewAccountMembers = ownsPermission('view-account-members')

	const viewInvoiceRequestCountries = getViewInvoiceRequestCountries(permissionsV2)
	const canViewAllInvoiceRequest = viewInvoiceRequestCountries.length > 0
	const canCancelInvoiceRequest = ownsPermission('can-cancel-invoice-request')

	return {
		permissions,
		permissionsV2,
		allowedMerchantCountries,
		createMerchantCountries,
		canCreateMerchant,
		canSignContract,
		canControlFeatures,
		canManageMarketCompetitors,
		canManageAdmins,
		canManageUsers,
		canSearchMerchants,
		canSearchMerchantsByPid,
		canManageCollections,
		canManageSuperdeals,
		canViewAccountMembers,
		canViewAllInvoiceRequest,
		viewInvoiceRequestCountries,
		canCancelInvoiceRequest,
		loading,
		error,
	}
}
